import { useContext, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { getClerkIdFromCookies } from '../utils/cookiesUtils';

export const useRequestsWithProgress = () => {
	const [progress, setProgress] = useState(0);
	const { token } = useContext(AuthContext);
	const postDocument = async (data) => {
		const { body, url, contentType = 'multipart/form-data' } = data;
		setProgress(0);
		try {
			const res = await axios.post(url, body, {
				headers: {
					'Content-Type': contentType,
					Authorization: `Bearer ${token}`,
					'clerk-id': getClerkIdFromCookies()
				},
				onUploadProgress: (progressEvent) => {
					const { loaded, total } = progressEvent;
					const percent = Math.floor((loaded * 100) / total);
					if (percent < 100) {
						setProgress(percent);
					}
				}
			});
			setProgress(0);
			return res;
		} catch (err) {
			console.error(err.response);
			setProgress(0);
			return err.response;
		}
	};
	const processDocumentWithOCR = async (data) => {
		const { body, url, contentType = 'multipart/form-data' } = data;
		setProgress(0);

		try {
			const res = await axios.post(url, body, {
				responseType: 'blob',
				headers: {
					'Content-Type': contentType
				},
				onUploadProgress: (progressEvent) => {
					const { loaded, total } = progressEvent;
					const percent = Math.floor((loaded * 100) / total);
					if (percent < 100) {
						setProgress(percent);
					}
				}
			});

			setProgress(0);
			return res;
		} catch (err) {
			console.error(err.response);
			setProgress(0);
		}
	};

	const putDocument = async (data) => {
		const { body, url, contentType = 'multipart/form-data' } = data;
		setProgress(0);
		try {
			const res = await axios.put(url, body, {
				headers: {
					'Content-Type': { contentType },
					Authorization: `Bearer ${token}`,
					'clerk-id': getClerkIdFromCookies()
				},
				onUploadProgress: (progressEvent) => {
					const { loaded, total } = progressEvent;
					const percent = Math.floor((loaded * 100) / total);
					if (percent < 100) {
						setProgress(percent);
					}
				}
			});
			setProgress(0);
			return res;
		} catch (err) {
			console.log(err.response);
			setProgress(0);
			return err.response;
		}
	};

	const putVideoOnS3 = async (data, onProgress) => {
		const { body, url, contentType = 'multipart/form-data' } = data;
		const videoContentType = contentType || body.type;
		setProgress(0);
		try {
			const res = await axios.put(url, body, {
				headers: {
					'Content-Type': videoContentType
				},
				onUploadProgress: (progressEvent) => {
					const { loaded, total } = progressEvent;
					const percent = Math.floor((loaded * 100) / total);
					onProgress(percent);
					if (percent < 100) {
						setProgress(percent);
					}
				}
			});
			setProgress(0);
			onProgress(100);

			return res;
		} catch (err) {
			console.error('Message', err.response);
			setProgress(0);
			onProgress(0);
			return err.response;
		}
	};

	const getDocument = async (data, withHeaders = true) => {
		const { url, responseType = 'blob' } = data;
		setProgress(0);
		try {
			const headers = withHeaders
				? {
						Authorization: `Bearer ${token}`
				  }
				: {};
			const res = await axios.get(url, {
				headers,
				responseType,
				onDownloadProgress: (progressEvent) => {
					const { loaded, total } = progressEvent;
					const percent = Math.floor((loaded * 100) / total);
					if (percent < 100) {
						setProgress(percent);
					}
				}
			});
			setProgress(0);
			return res;
		} catch (err) {
			console.error('Message', err.response);
			setProgress(0);
			return err.response;
		}
	};

	return {
		getDocument,
		postDocument,
		putDocument,
		progress,
		putVideoOnS3,
		processDocumentWithOCR
	};
};
